<template>
    <div>
        <login-form
            v-if="step == 0"
            ref="loginForm"
            :loading="loading"
            :step="loginFormStep"
            @submited="(form) => loginFormStep ? login(form['password']) : checkUsername(form[username_type], false)"
            @forgotPassword="requestResetPassword"
            @cancell="loginFormStep = 0"
        ></login-form>
        <otp-form
            v-if="step == 1"
            ref="otpForm"
            :buttonText="isReset ? 'تایید' : 'ورود به سامانه'"
            :buttonIcon="isReset ? 'icon-closeticket' : 'icon-enter'"
            :loading="loading"
            @submited="(code) => isReset ? verifyResetToken(code) : login(code)"
            @resend="checkUsername"
            @cancell="step = 0; loginFormStep = 0;"
        ></otp-form>
        <reset-password-form
            v-if="step == 2"
            :loading="loading"
            @submited="resetPassword"
        ></reset-password-form>
    </div>
</template>
<script>
export default {
    layout: "auth",
    auth: "guest",
    data () {
        return {
            step: 0,
            token: null,
            loading: false,
            loginFormStep: 0,
            isReset: false,
            username_type: this.$system.systemSettings.username_type,
            username: null
        }
    },
    methods: {
        async checkUsername(username = null, isReset = null) {
            this.loading = true;
            if (username !== null) this.username = username;
            if (isReset !== null) this.isReset = isReset;
            let res = await this.$checkUsername({[this.username_type]: this.username, reset: this.isReset});
            if (res && res.status == 'OK') {
                if(res.data.type == 'otp') {
                    this.step = 1;
                    setTimeout(() => { this.$refs.otpForm.initial() }, 1);
                } else {
                    this.loginFormStep = 1;
                }
            }
            this.loading = false;
        },
        async login(password) {
            this.loading = true;
            await this.$auth.login({[this.username_type]: this.username, password});
            this.loading = false
        },
        async verifyResetToken(password) {
            this.loading = true;
            await this.$passwordResetToken({[this.username_type]: this.username, password}).then((res) => {
                if(res && res.status == 'OK') {
                    this.token = res.data.token;
                    this.step = 2;
                }
            });
            this.loading = false;
        },
        async requestResetPassword() {
            this.$confirm(`<p class="mb-0 font-weight-medium mt-2">آیا از انجام این عملیات اطمینان دارید؟</p><p class="text-small mb-0 mt-2">در صورت تأیید، کد اعتبارسنجی به ایمیل/موبایل ثبت شده در پروفایل شما ارسال خواهد گردید.</p>`)
                .then((res) => { if (res) this.checkUsername(null, true) });
        },
        async resetPassword(password) {
            this.loading = true;
            let res = await this.$passwordReset({password, token: this.token});
            if (res && res.status == "OK") {
                this.step = 0;
                this.loginFormStep = 0;
                this.$toast.success(res.message);
            }
            this.loading = false;
        }
    },
    beforeMount() {
        if (Object.hasOwn(this.$route.query, this.username_type)) {
            this.$router.replace({ query: {} });
            this.$refs.loginForm.setInitialValue(this.$route.query[this.username_type]);
            this.checkUsername(this.$route.query[this.username_type], false);
        }
    }
};
</script>
